import { httpClient } from '../http-client';
import { ApiResponse } from '../../types/responses/api-response';

export interface PushSubscriptionPayload {
  endpoint: string;
  keys: {
    p256dh: string;
    auth: string;
  };
  deviceInfo?: {
    userAgent?: string;
    platform?: string;
    language?: string;
    timezone?: string;
    deviceName?: string;
  };
}

export interface PushSubscriptionEntity extends PushSubscriptionPayload {
  id?: string;
  userId?: string;
  createdAt?: string;
  updatedAt?: string;
}

export const mobilePushApi = {
  /**
   * Получение публичного VAPID ключа
   * GET /api/mobile/push/vapid-key
   */
  getPublicKey: async (): Promise<string> => {
    const response = await httpClient.get<{ publicKey: string }>('/mobile/push/vapid-key');
    return response.data?.publicKey || '';
  },

  /**
   * Подписка на push-уведомления
   * POST /api/mobile/push/subscribe
   */
  subscribe: async (payload: PushSubscriptionPayload): Promise<ApiResponse<{ message: string }>> => {
    return httpClient.post('/mobile/push/subscribe', payload);
  },

  /**
   * Отписка от push-уведомлений
   * DELETE /api/mobile/push/subscribe
   */
  unsubscribe: async (endpoint: string): Promise<ApiResponse<{ message: string }>> => {
    return httpClient.delete('/mobile/push/subscribe', {
      data: { endpoint },
    });
  },

  /**
   * Получение списка подписок пользователя
   * GET /api/mobile/push/subscriptions
   */
  getSubscriptions: async (): Promise<ApiResponse<PushSubscriptionEntity[]>> => {
    return httpClient.get('/mobile/push/subscriptions');
  },

  /**
   * Отправка тестового уведомления
   * POST /api/mobile/push/send
   */
  sendTest: async (userId?: string): Promise<ApiResponse<{ message: string }>> => {
    return httpClient.post('/mobile/push/send', userId ? { userId } : undefined);
  },
};

export default mobilePushApi;

